<div class="container">
  <h3>{{filling?.name}}</h3>
  @if (description) {
    <div class="description" [innerHTML]="description"></div>
  }
  <div class="image">
    <img [src]="imageUrl" alt="" defaultImg>
  </div>
  @if (button) {
    <button mat-raised-button color="primary" (click)="close()">
      {{ 'INTERFACE|Wybierz' | translate }}
    </button>
  }
</div>

